export const VALUE = "VALUE"
export const PERCENTAGE = "PERCENTAGE"
